// extracted by mini-css-extract-plugin
export default {"root":"RDMOTtdV","multiple":"naX5mpZn","popup":"MrRuzoEA","block":"RZrdYNUY"};